import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COLORS, EXTENDS, FONT_FAMILY } from '../constants/styles';
import ICONS from '../constants/icons';

import Icon from '../components/Icon';
import { InfoTooltip } from './InfoTooltip';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
const CheckboxWrapper = styled.div`
    padding-right: 20px;
    position: relative;
`;

const LabelTextWrapper = styled.span`
    padding-top: 5px;
`;

const Input = styled.input`
    ${EXTENDS.isVisualyHidden};
    color: ${COLORS.rakutenRed};
`;

const Label = styled.label`
    align-items: center;
    padding-left: 23px;
    position: relative;
    cursor: pointer;
    height: 25px;
    display: flex;
    ${FONT_FAMILY.multipleRegularCss};
    font-size: 0.75rem;
    font-weight: 300;
    color: ${COLORS.grey7};
    &:has(${Input}:focus-visible) {
        outline: 2px solid #3361c5;
        outline-offset: 2px;
        border-radius: 1px;
    }
`;

const Indicator = styled.span`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 3px;
    top: 7px;
    width: 16px;
    height: 16px;
    border: 2px solid;
    border-color: ${(props) => (props.active ? COLORS.rakutenRed : COLORS.grey)};
    padding: 5px;
    border-radius: 5px;
    background-color: ${(props) => (props.active ? COLORS.rakutenRed : COLORS.white)};

    &.error {
        background-color: ${COLORS.white};
        border-color: ${COLORS.rakutenRed};
    }
`;

const Tick = styled.span`
    margin-top: -8px;
    width: 12px;
    height: 9px;
    display: block;
    color: ${COLORS.white};
`;

const Checkbox = ({
    id,
    name,
    value,
    onChange,
    onBlur,
    ariaLabel,
    shownError,
    label,
    tooltipText,
    className,
}) => (
    <CheckboxWrapper className={className}>
        <Label htmlFor={id}>
            <Input
                name={name}
                id={id}
                type="checkbox"
                value={value}
                checked={value}
                onChange={onChange}
                onBlur={onBlur}
                aria-label={ariaLabel}
            />
            <Indicator active={value} className={shownError ? 'error' : ''}>
                {value && (
                    <Tick>
                        <Icon size="12" icon={ICONS.CHECK} />
                    </Tick>
                )}
            </Indicator>
            {label && (
                <LabelTextWrapper>{TranslationHelpers.getFormattedMessage(label)}</LabelTextWrapper>
            )}
        </Label>
        {tooltipText ? <InfoTooltip id={id} tooltipText={tooltipText} uniqueId={id} /> : ''}
    </CheckboxWrapper>
);

Checkbox.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    ariaLabel: PropTypes.string,
    shownError: PropTypes.bool,
    label: PropTypes.string,
    className: PropTypes.string,
};

export default Checkbox;
